import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_order",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { class: "row container-fluid mt-2 d-flex w-100" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Information additionnelle :", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 1,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_details = _resolveComponent("order-details")!
  const _component_order_delivery = _resolveComponent("order-delivery")!
  const _component_order_customer = _resolveComponent("order-customer")!
  const _component_order_products = _resolveComponent("order-products")!
  const _component_order_payment = _resolveComponent("order-payment")!
  const _component_btn_default = _resolveComponent("btn-default")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, "Commande N° " + _toDisplayString(_ctx.order?.id ?? ''), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_order', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_order_details),
              _createVNode(_component_order_delivery),
              _createVNode(_component_order_customer),
              _createVNode(_component_order_products),
              _createVNode(_component_order_payment),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.order?.comment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.order?.comment), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_btn_default, {
                btnClass: `btn-primary`,
                onDefault: _cache[1] || (_cache[1] = ($event: any) => (_ctx.print(_ctx.order))),
                title: `Imprimer`
              }),
              _createVNode(_component_btn_default, {
                btnClass: `btn-secondary`,
                onDefault: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal('modal_order', 'add'))),
                title: `Fermer`
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}